import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { CancelSubscriptionConfirmationModal } from './components/CancelSubscriptionConfirmationModal';
import { CancelSubscriptionUpsellModal } from './components/CancelSubscriptionUpsellModal';
import { useStopContributions } from './hooks/useStopContributions';

export const StopContributions: React.FC = () => {
	const {
		data: { i18nSuffix, showUpsell },
		actions: { cancelSubscription },
	} = useStopContributions();

	const CancelModal = showUpsell ? CancelSubscriptionUpsellModal : CancelSubscriptionConfirmationModal;

	return (
		<div className="flex flex-col gap-4 pt-4">
			<Text as="h2" size="x-small" variant="heading" fontWeight="bold">
				<Translate value={`corgi.membership.manage.cancel.label${i18nSuffix}`} />
			</Text>

			<CancelModal
				trigger={
					<Text as="p">
						<Translate value="corgi.membership.manage.cancel.description" />{' '}
						<Link
							className="text-left"
							as="button"
							type="button"
							onClick={cancelSubscription}
							data-testid="cancel-membership-link"
							data-qa="cancel-membership-link"
						>
							<Translate value={`corgi.membership.manage.cancel.action${i18nSuffix}`} />
						</Link>
					</Text>
				}
			/>
		</div>
	);
};
